<template>
    <component :is="template">
        <router-question />
    </component>
</template>
<script>
import RouterQuestion from "@/components/client/center/question/router-question.vue";
export default {
    components: {
        RouterQuestion
    },
    mounted(){
        if(this.logoff) this.$router.push(`/login`);
    },
    computed: {
        template(){
            return () => import(`@/templates/${this.$theme.pages.center}`);
        },
        logoff(){
            return !this.$store.state.accessToken;
        }
    }
}
</script>

<style scoped>
.center-question .title {
    font-size: 22px !important;
    font-weight: 600;
}
</style>